import axiosInstance from "@/utils/axiosInstance";
import store from "@/store";

const baseUrl = `api/relays`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getAll({commit}, payload: {query: object}) {
      return axiosInstance.get(baseUrl, {params: {
        ...payload.query,
        companyId: store.getters.envCompanyId,
      }}).then((data) => data.data);
    },
    getById({commit}, payload: {id: number}) {
        return axiosInstance.get(`${baseUrl}/${payload.id}`)
            .then((data) => data.data);
    },
    getPresetUsersById({commit}, payload: {id: number}) {
        return axiosInstance.get(`${baseUrl}/${payload.id}/preset-users`)
            .then((data) => data.data);
    },
    getKeyStatsById({commit}, payload: {id: number}) {
        return axiosInstance.get(`${baseUrl}/${payload.id}/keys-stats`)
            .then((data) => data.data);
    },
    update({commit},  payload: {id: number, relay: object}) {
        return axiosInstance.put(`${baseUrl}/${payload.id}`, {relay: payload.relay})
            .then((data) => data.data);
    },
    createRelay({commit}, payload: {relay: object, address: object, companyId: number}) {
        return axiosInstance.post(baseUrl, {
          relay: payload.relay,
          address: payload.address,
          companyId: payload.companyId,
        }).then((data) => data.data);
    },
    createInvoice({commit}, payload: {id: number, invoiceData: object}) {
        return axiosInstance.post(`${baseUrl}/${payload.id}/invoices`, {invoiceData: payload.invoiceData})
            .then((data) => data.data);
    },
    notifyExceptionalClosure({commit}, payload: {relayId: number, exceptionalClosure: any}) {
      return axiosInstance.post(`${baseUrl}/${payload.relayId}/closure-notification`, {
        exceptionalClosure: payload.exceptionalClosure,
      }).then((data) => data.data);
    },
    pinVerificationToGuest({commit}, payload: {relayId: number, pin: number, guest: any}) {
      return axiosInstance.post(`${baseUrl}/${payload.relayId}/pinVerificationToGuest`,
        {pin: payload.pin, guest: payload.guest})
        .then((data) => data.data);
    },
    getKeys({commit}, payload: {relayId: number, query: object}) {
      return axiosInstance.get(`${baseUrl}/${payload.relayId}/keys`, {params: payload?.query})
      .then((data) => data.data);
    },
    getAlertKeys({commit}, payload: {relayId: number}) {
      return axiosInstance.get(`${baseUrl}/${payload.relayId}/alert-keys`)
      .then((data) => data.data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
